import { Injectable } from '@angular/core';
import {Country} from "../../model/country";
import {State} from "../../model/state";

@Injectable()
export class StateDataService {

  constructor() { }


  getCountries() {
    return [
      new  Country(1,'Afghanistan',  'AF'),
      new  Country(2,'Åland Islands',  'AX'),
      new  Country(3,'Albania',  'AL'),
      new  Country(4,'Algeria',  'DZ'),
      new  Country(5,'American Samoa',  'AS'),
      new  Country(6,'AndorrA',  'AD'),
      new  Country(7,'Angola',  'AO'),
      new  Country(8,'Anguilla',  'AI'),
      new  Country(9,'Antarctica',  'AQ'),
      new  Country(10,'Antigua and Barbuda',  'AG'),
      new  Country(11,'Argentina',  'AR'),
      new  Country(12,'Armenia',  'AM'),
      new  Country(13,'Aruba',  'AW'),
      new  Country(14,'Australia',  'AU'),
      new  Country(15,'Austria',  'AT'),
      new  Country(16,'Azerbaijan',  'AZ'),
      new  Country(17,'Bahamas',  'BS'),
      new  Country(18,'Bahrain',  'BH'),
      new  Country(19,'Bangladesh',  'BD'),
      new  Country(20,'Barbados',  'BB'),
      new  Country(21,'Belarus',  'BY'),
      new  Country(22,'Belgium',  'BE'),
      new  Country(23,'Belize',  'BZ'),
      new  Country(24,'Benin',  'BJ'),
      new  Country(25,'Bermuda',  'BM'),
      new  Country(26,'Bhutan',  'BT'),
      new  Country(27,'Bolivia',  'BO'),
      new  Country(28,'Bosnia and Herzegovina',  'BA'),
      new  Country(29,'Botswana',  'BW'),
      new  Country(30,'Bouvet Island',  'BV'),
      new  Country(31,'Brazil',  'BR'),
      new  Country(32,'British Indian Ocean Territory',  'IO'),
      new  Country(33,'Brunei Darussalam',  'BN'),
      new  Country(34,'Bulgaria',  'BG'),
      new  Country(35,'Burkina Faso',  'BF'),
      new  Country(36,'Burundi',  'BI'),
      new  Country(37,'Cambodia',  'KH'),
      new  Country(38,'Cameroon',  'CM'),
      new  Country(39,'Canada',  'CA'),
      new  Country(40,'Cape Verde',  'CV'),
      new  Country(41,'Cayman Islands',  'KY'),
      new  Country(42,'Central African Republic',  'CF'),
      new  Country(43,'Chad',  'TD'),
      new  Country(44,'Chile',  'CL'),
      new  Country(45,'China',  'CN'),
      new  Country(46,'Christmas Island',  'CX'),
      new  Country(47,'Cocos (Keeling) Islands',  'CC'),
      new  Country(48,'Colombia',  'CO'),
      new  Country(49,'Comoros',  'KM'),
      new  Country(50,'Congo',  'CG'),
      new  Country(51,'Congo, The Democratic Republic of the',  'CD'),
      new  Country(52,'Cook Islands',  'CK'),
      new  Country(53,'Costa Rica',  'CR'),
      new  Country(54,'Cote D\'Ivoire',  'CI'),
      new  Country(55,'Croatia',  'HR'),
      new  Country(56,'Cuba',  'CU'),
      new  Country(57,'Cyprus',  'CY'),
      new  Country(58,'Czech Republic',  'CZ'),
      new  Country(59,'Denmark',  'DK'),
      new  Country(60,'Djibouti',  'DJ'),
      new  Country(61,'Dominica',  'DM'),
      new  Country(62,'Dominican Republic',  'DO'),
      new  Country(63,'Ecuador',  'EC'),
      new  Country(64,'Egypt',  'EG'),
      new  Country(65,'El Salvador',  'SV'),
      new  Country(66,'Equatorial Guinea',  'GQ'),
      new  Country(67,'Eritrea',  'ER'),
      new  Country(68,'Estonia',  'EE'),
      new  Country(69,'Ethiopia',  'ET'),
      new  Country(70,'Falkland Islands (Malvinas)',  'FK'),
      new  Country(71,'Faroe Islands',  'FO'),
      new  Country(72,'Fiji',  'FJ'),
      new  Country(73,'Finland',  'FI'),
      new  Country(74,'France',  'FR'),
      new  Country(75,'French Guiana',  'GF'),
      new  Country(76,'French Polynesia',  'PF'),
      new  Country(77,'French Southern Territories',  'TF'),
      new  Country(78,'Gabon',  'GA'),
      new  Country(79,'Gambia',  'GM'),
      new  Country(80,'Georgia',  'GE'),
      new  Country(81,'Germany',  'DE'),
      new  Country(82,'Ghana',  'GH'),
      new  Country(83,'Gibraltar',  'GI'),
      new  Country(84,'Greece',  'GR'),
      new  Country(85,'Greenland',  'GL'),
      new  Country(86,'Grenada',  'GD'),
      new  Country(87,'Guadeloupe',  'GP'),
      new  Country(88,'Guam',  'GU'),
      new  Country(89,'Guatemala',  'GT'),
      new  Country(90,'Guernsey',  'GG'),
      new  Country(91,'Guinea',  'GN'),
      new  Country(92,'Guinea-Bissau',  'GW'),
      new  Country(93,'Guyana',  'GY'),
      new  Country(94,'Haiti',  'HT'),
      new  Country(95,'Heard Island and Mcdonald Islands',  'HM'),
      new  Country(96,'Holy See (Vatican City State)',  'VA'),
      new  Country(97,'Honduras',  'HN'),
      new  Country(98,'Hong Kong',  'HK'),
      new  Country(99,'Hungary',  'HU'),
      new  Country(100,'Iceland',  'IS'),
      new  Country(101,'India',  'IN'),
      new  Country(102,'Indonesia',  'ID'),
      new  Country(103,'Iran, Islamic Republic Of',  'IR'),
      new  Country(104,'Iraq',  'IQ'),
      new  Country(105,'Ireland',  'IE'),
      new  Country(106,'Isle of Man',  'IM'),
      new  Country(107,'Israel',  'IL'),
      new  Country(108,'Italy',  'IT'),
      new  Country(109,'Jamaica',  'JM'),
      new  Country(110,'Japan',  'JP'),
      new  Country(111,'Jersey',  'JE'),
      new  Country(112,'Jordan',  'JO'),
      new  Country(113,'Kazakhstan',  'KZ'),
      new  Country(114,'Kenya',  'KE'),
      new  Country(115,'Kiribati',  'KI'),
      new  Country(116,'Korea, Democratic People\'S Republic of',  'KP'),
      new  Country(117,'Korea, Republic of',  'KR'),
      new  Country(118,'Kuwait',  'KW'),
      new  Country(119,'Kyrgyzstan',  'KG'),
      new  Country(120,'Lao People\'S Democratic Republic',  'LA'),
      new  Country(121,'Latvia',  'LV'),
      new  Country(122,'Lebanon',  'LB'),
      new  Country(123,'Lesotho',  'LS'),
      new  Country(124,'Liberia',  'LR'),
      new  Country(125,'Libyan Arab Jamahiriya',  'LY'),
      new  Country(126,'Liechtenstein',  'LI'),
      new  Country(127,'Lithuania',  'LT'),
      new  Country(128,'Luxembourg',  'LU'),
      new  Country(129,'Macao',  'MO'),
      new  Country(130,'Macedonia, The Former Yugoslav Republic of',  'MK'),
      new  Country(131,'Madagascar',  'MG'),
      new  Country(132,'Malawi',  'MW'),
      new  Country(133,'Malaysia',  'MY'),
      new  Country(134,'Maldives',  'MV'),
      new  Country(135,'Mali',  'ML'),
      new  Country(136,'Malta',  'MT'),
      new  Country(137,'Marshall Islands',  'MH'),
      new  Country(138,'Martinique',  'MQ'),
      new  Country(139,'Mauritania',  'MR'),
      new  Country(140,'Mauritius',  'MU'),
      new  Country(141,'Mayotte',  'YT'),
      new  Country(142,'Mexico',  'MX'),
      new  Country(143,'Micronesia, Federated States of',  'FM'),
      new  Country(144,'Moldova, Republic of',  'MD'),
      new  Country(145,'Monaco',  'MC'),
      new  Country(146,'Mongolia',  'MN'),
      new  Country(147,'Montserrat',  'MS'),
      new  Country(148,'Morocco',  'MA'),
      new  Country(149,'Mozambique',  'MZ'),
      new  Country(150,'Myanmar',  'MM'),
      new  Country(151,'Namibia',  'NA'),
      new  Country(152,'Nauru',  'NR'),
      new  Country(153,'Nepal',  'NP'),
      new  Country(154,'Netherlands',  'NL'),
      new  Country(155,'Netherlands Antilles',  'AN'),
      new  Country(156,'New Caledonia',  'NC'),
      new  Country(157,'New Zealand',  'NZ'),
      new  Country(158,'Nicaragua',  'NI'),
      new  Country(159,'Niger',  'NE'),
      new  Country(160,'Nigeria',  'NG'),
      new  Country(171,'Niue',  'NU'),
      new  Country(172,'Norfolk Island',  'NF'),
      new  Country(173,'Northern Mariana Islands',  'MP'),
      new  Country(174,'Norway',  'NO'),
      new  Country(175,'Oman',  'OM'),
      new  Country(176,'Pakistan',  'PK'),
      new  Country(177,'Palau',  'PW'),
      new  Country(178,'Palestinian Territory, Occupied',  'PS'),
      new  Country(179,'Panama',  'PA'),
      new  Country(180,'Papua New Guinea',  'PG'),
      new  Country(181,'Paraguay',  'PY'),
      new  Country(182,'Peru',  'PE'),
      new  Country(183,'Philippines',  'PH'),
      new  Country(184,'Pitcairn',  'PN'),
      new  Country(185,'Poland',  'PL'),
      new  Country(186,'Portugal',  'PT'),
      new  Country(187,'Puerto Rico',  'PR'),
      new  Country(188,'Qatar',  'QA'),
      new  Country(189,'Reunion',  'RE'),
      new  Country(190,'Romania',  'RO'),
      new  Country(191,'Russian Federation',  'RU'),
      new  Country(192,'RWANDA',  'RW'),
      new  Country(193,'Saint Helena',  'SH'),
      new  Country(194,'Saint Kitts and Nevis',  'KN'),
      new  Country(195,'Saint Lucia',  'LC'),
      new  Country(196,'Saint Pierre and Miquelon',  'PM'),
      new  Country(197,'Saint Vincent and the Grenadines',  'VC'),
      new  Country(198,'Samoa',  'WS'),
      new  Country(199,'San Marino',  'SM'),
      new  Country(200,'Sao Tome and Principe',  'ST'),
      new  Country(201,'Saudi Arabia',  'SA'),
      new  Country(202,'Senegal',  'SN'),
      new  Country(203,'Serbia and Montenegro',  'CS'),
      new  Country(204,'Seychelles',  'SC'),
      new  Country(205,'Sierra Leone',  'SL'),
      new  Country(206,'Singapore',  'SG'),
      new  Country(207,'Slovakia',  'SK'),
      new  Country(208,'Slovenia',  'SI'),
      new  Country(209,'Solomon Islands',  'SB'),
      new  Country(210,'Somalia',  'SO'),
      new  Country(211,'South Africa',  'ZA'),
      new  Country(212,'South Georgia and the South Sandwich Islands',  'GS'),
      new  Country(213,'Spain',  'ES'),
      new  Country(214,'Sri Lanka',  'LK'),
      new  Country(215,'Sudan',  'SD'),
      new  Country(216,'Suriname',  'SR'),
      new  Country(217,'Svalbard and Jan Mayen',  'SJ'),
      new  Country(218,'Swaziland',  'SZ'),
      new  Country(219,'Sweden',  'SE'),
      new  Country(220,'Switzerland',  'CH'),
      new  Country(221,'Syrian Arab Republic',  'SY'),
      new  Country(222,'Taiwan, Province of China',  'TW'),
      new  Country(223,'Tajikistan',  'TJ'),
      new  Country(224,'Tanzania, United Republic of',  'TZ'),
      new  Country(225,'Thailand',  'TH'),
      new  Country(226,'Timor-Leste',  'TL'),
      new  Country(227,'Togo',  'TG'),
      new  Country(228,'Tokelau',  'TK'),
      new  Country(229,'Tonga',  'TO'),
      new  Country(230,'Trinidad and Tobago',  'TT'),
      new  Country(231,'Tunisia',  'TN'),
      new  Country(232,'Turkey',  'TR'),
      new  Country(233,'Turkmenistan',  'TM'),
      new  Country(234,'Turks and Caicos Islands',  'TC'),
      new  Country(235,'Tuvalu',  'TV'),
      new  Country(236,'Uganda',  'UG'),
      new  Country(237,'Ukraine',  'UA'),
      new  Country(238,'United Arab Emirates',  'AE'),
      new  Country(239,'United Kingdom',  'GB'),
      new  Country(240,'United States',  'US'),
      new  Country(241,'United States Minor Outlying Islands',  'UM'),
      new  Country(242,'Uruguay',  'UY'),
      new  Country(243,'Uzbekistan',  'UZ'),
      new  Country(244,'Vanuatu',  'VU'),
      new  Country(245,'Venezuela',  'VE'),
      new  Country(246,'Viet Nam',  'VN'),
      new  Country(247,'Virgin Islands, British',  'VG'),
      new  Country(248,'Virgin Islands, U.S.',  'VI'),
      new  Country(249,'Wallis and Futuna',  'WF'),
      new  Country(250,'Western Sahara',  'EH'),
      new  Country(251,'Yemen',  'YE'),
      new  Country(252,'Zambia',  'ZM'),
      new  Country(253,'Zimbabwe',  'ZW')
  ];
  }

    getStates() {
      return [
        new State(1,  1,   'AL','Alabama'),
        new State(2,  1,   'AK','Alaska'),
        new State(3,  1,   'AS','American Samoa'),
        new State(4,  1,   'AZ','Arizona'),
        new State(5,  1,   'AR','Arkansas'),
        new State(6,  1,   'CA','California'),
        new State(7,  1,   'CO','Colorado'),
        new State(8,  1,   'CT','Connecticut'),
        new State(9,  1,   'DE','Delaware'),
        new State(10, 1,   'DC','District Of Columbia'),
        new State(11, 1,   'FM','Federated States Of Micronesia'),
        new State(12, 1,   'FL','Florida'),
        new State(13, 1,   'GA','Georgia'),
        new State(14, 1,   'GU','Guam'),
        new State(15, 1,   'HI','Hawaii'),
        new State(16, 1,   'ID','Idaho'),
        new State(17, 1,   'IL','Illinois'),
        new State(18, 1,   'IN','Indiana'),
        new State(19, 1,   'IA','Iowa'),
        new State(20, 1,   'KS','Kansas'),
        new State(21, 1,   'KY','Kentucky'),
        new State(22, 1,   'LA','Louisiana'),
        new State(23, 1,   'ME','Maine'),
        new State(24, 1,   'MH','Marshall Islands'),
        new State(25, 1,   'MD','Maryland'),
        new State(26, 1,   'MA','Massachusetts'),
        new State(27, 1,   'MI','Michigan'),
        new State(28, 1,   'MN','Minnesota'),
        new State(29, 1,   'MS','Mississippi'),
        new State(30, 1,   'MO','Missouri'),
        new State(31, 1,   'MT','Montana'),
        new State(32, 1,   'NE','Nebraska'),
        new State(33, 1,   'NV','Nevada'),
        new State(34, 1,   'NH','New Hampshire'),
        new State(35, 1,   'NJ','New Jersey'),
        new State(36, 1,   'NM','New Mexico'),
        new State(37, 1,   'NY','New York'),
        new State(38, 1,   'NC','North Carolina'),
        new State(39, 1,   'ND','North Dakota'),
        new State(40, 1,   'MP','Northern Mariana Islands'),
        new State(41, 1,   'OH','Ohio'),
        new State(42, 1,   'OK','Oklahoma'),
        new State(43, 1,   'OR','Oregon'),
        new State(44, 1,   'PW','Palau'),
        new State(45, 1,   'PA','Pennsylvania'),
        new State(46, 1,   'PR','Puerto Rico'),
        new State(47, 1,   'RI','Rhode Island'),
        new State(48, 1,   'SC','South Carolina'),
        new State(49, 1,   'SD','South Dakota'),
        new State(50, 1,   'TN','Tennessee'),
        new State(51, 1,   'TX','Texas'),
        new State(52, 1,   'UT','Utah'),
        new State(53, 1,   'VT','Vermont'),
        new State(54, 1,   'VI','Virgin Islands'),
        new State(55, 1,   'VA','Virginia'),
        new State(56, 1,   'WA','Washington'),
        new State(57, 1,   'WV','West Virginia'),
        new State(58, 1,   'WI','Wisconsin'),
        new State(59, 1,   'WY','Wyoming')

      ];
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/state/state-data.service.ts